import { Link } from "react-router-dom";
import { Download } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-neutral-200 bg-neutral-50 mt-24">
      <div className="max-w-7xl mx-auto px-5 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <span className="font-display text-3xl font-black text-[#E8956B] tracking-tighter">BTC</span>
          <p className="text-base font-semibold text-neutral-900 mt-3 max-w-xs">
            The community marketplace to buy, sell & trade your favorite new and gently used beauty finds.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-extrabold uppercase tracking-[0.2em] text-[#E8956B] mb-4">Marketplace</h4>
          <ul className="space-y-2 text-base font-semibold text-neutral-900">
            <li><Link to="/shop" className="hover:text-neutral-900">Shop All</Link></li>
            <li><Link to="/sell" className="hover:text-neutral-900">Sell an Item</Link></li>
            <li><Link to="/how-it-works" className="hover:text-neutral-900">How It Works</Link></li>
            <li><Link to="/clean-guide" className="hover:text-neutral-900" data-testid="footer-clean-guide-link">Cleaning Guide</Link></li>
            <li><Link to="/advertise" className="hover:text-neutral-900" data-testid="footer-advertise-link">Advertise with Us</Link></li>
            <li>
              <button
                data-testid="footer-get-app-btn"
                onClick={() => window.dispatchEvent(new Event("btc-show-install"))}
                className="inline-flex items-center gap-1.5 text-[#E8956B] hover:text-[#CE744A]"
              >
                <Download size={15} /> Get the App
              </button>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-extrabold uppercase tracking-[0.2em] text-[#E8956B] mb-4">Company</h4>
          <ul className="space-y-2 text-base font-semibold text-neutral-900">
            <li><Link to="/about" className="hover:text-neutral-900">About Us</Link></li>
            <li><Link to="/we-love" className="hover:text-neutral-900" data-testid="footer-we-love-link">We Love</Link></li>
            <li><span className="hover:text-neutral-900 cursor-pointer">Contact</span></li>
            <li><span className="hover:text-neutral-900 cursor-pointer">Trust & Safety</span></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-extrabold uppercase tracking-[0.2em] text-[#E8956B] mb-4">Legal</h4>
          <ul className="space-y-2 text-base font-semibold text-neutral-900">
            <li><Link to="/returns" className="hover:text-neutral-900" data-testid="footer-returns-link">Return Policy</Link></li>
            <li><span className="hover:text-neutral-900 cursor-pointer">Terms</span></li>
            <li><span className="hover:text-neutral-900 cursor-pointer">Privacy</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-200 py-5 text-center text-sm font-bold text-neutral-900">
        © 2026 Beauty Trade Club. Authentic products only. Safe & secure transactions.
      </div>
    </footer>
  );
}
